import React from 'react';
import c from 'classnames';
import s from './SimpleTooltipText.scss';
var SimpleTooltipText = function (_a) {
    var children = _a.children, className = _a.className;
    return React.createElement("span", { className: c(s['root'], className) }, children);
};
SimpleTooltipText.displayName = 'SimpleTooltipText';
export default SimpleTooltipText;
//# sourceMappingURL=SimpleTooltipText.js.map